import { Observable } from 'rxjs';

export function fromMutationObserver(targetNode: Node, options: MutationObserverInit): Observable<MutationRecord[]> {
  return new Observable((subscriber) => {
    const observer = new MutationObserver((mutations) => {
      subscriber.next(mutations);
    });

    observer.observe(targetNode, options);

    return () => {
      observer.disconnect();
    };
  });
}
